import React from 'react';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import cx from 'classnames';

const View = (props) => {
  const { data } = props;
  const metadata = props.metadata || props.properties;
  const customId = data?.title
    ?.toLowerCase()
    ?.replace(/[^a-zA-Z-\s]/gi, '')
    ?.trim()
    ?.replace(/\s+/gi, '-');

  const classes = cx('d-none', {
    'd-block': data.phone,
    'd-sm-none': !data.tablet,
    'd-sm-block': data.tablet,
    'd-md-none': !data.desktop,
    'd-md-block': data.desktop,
  });

  return (
    <div id={customId} className={classes}>
      <RenderBlocks {...props} metadata={metadata} content={data?.data || {}} />
    </div>
  );
};

export default View;
